module.exports = __webpack_public_path__ + "static/media/OrderReceiptTile.3866242c.jpg";